const ROOT = "videoPlayer";
const REACT_PLAYER_FILE = "reactPlayerFile";
const INSERT_PLUGIN_MODAL = "videoMediaUrlModal";
const INSERT_PLUGIN_MODAL_TABS = "insertPluginModalTabs";
const EMBED_TAB = "Embed_Tab";
const EMBED_TAB_URL_INPUT = "videoMediaUrlModalInput";
const EMBED_TAB_SUBMIT_BUTTON = "actionButtonSave";
const UPLOAD_TAB = "Upload_Tab";
const UPLOAD_TAB_UPLOAD_BUTTON = "videoUploadModalCustomVideo";
const SETTINGS_ALLOW_DOWNALOD_TOGGLE = "videoDownloadToggle";
const SETTINGS_SPOILER_TOGGLE = "videoSpoilerToggle";
export {
  EMBED_TAB,
  EMBED_TAB_SUBMIT_BUTTON,
  EMBED_TAB_URL_INPUT,
  INSERT_PLUGIN_MODAL,
  INSERT_PLUGIN_MODAL_TABS,
  REACT_PLAYER_FILE,
  ROOT,
  SETTINGS_ALLOW_DOWNALOD_TOGGLE,
  SETTINGS_SPOILER_TOGGLE,
  UPLOAD_TAB,
  UPLOAD_TAB_UPLOAD_BUTTON
};
//# sourceMappingURL=dataHooks.js.map
